// DRF(Django REST Framework) error response parser
// Returns: { form: string, fields: Record<string, string> }
export function parseDRFErrors(data) {
  const out = { form: "", fields: {} };

  if (!data) return out;

  // If backend returns a plain string
  if (typeof data === "string") {
    out.form = data;
    return out;
  }

  // If backend returns a list of strings
  if (Array.isArray(data)) {
    out.form = data.filter(Boolean).join("\n");
    return out;
  }

  // Object shape
  if (typeof data === "object") {
    // common DRF keys
    const detail = data.detail;
    const nonField = data.non_field_errors || data.nonFieldErrors || data.nonField;

    const collectMessages = (value, path = "", includePath = false) => {
      if (value === null || value === undefined || value === "") return [];
      if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
        const message = String(value);
        return includePath && path ? [`${path}: ${message}`] : [message];
      }
      if (Array.isArray(value)) {
        return value.flatMap((item, index) => {
          const itemIsObject = item !== null && typeof item === "object" && !Array.isArray(item);
          const explicitIndex = itemIsObject && item.index !== undefined ? item.index : index;
          const nextPath = itemIsObject && path ? `${path}[${explicitIndex}]` : path;
          return collectMessages(item, nextPath, includePath || itemIsObject);
        });
      }
      if (typeof value === "object") {
        return Object.entries(value).flatMap(([key, nested]) => {
          if (key === "index" && Object.keys(value).length > 1) return [];
          const nextPath = path ? `${path}.${key}` : key;
          return collectMessages(nested, nextPath, true);
        });
      }
      return [String(value)];
    };

    const toMsg = (v, path = "") => {
      if (!v) return "";
      return collectMessages(v, path).filter(Boolean).join("\n");
    };

    const formMsg = [toMsg(detail), toMsg(nonField)].filter(Boolean).join("\n");
    if (formMsg) out.form = formMsg;

    Object.entries(data).forEach(([k, v]) => {
      if (k === "detail" || k === "non_field_errors" || k === "nonFieldErrors" || k === "nonField" ) return;
      const msg = toMsg(v, k);
      if (msg) out.fields[k] = msg;
    });

    return out;
  }

  out.form = String(data);
  return out;
}
